"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const getRecentPausedTime = () => {
    let time = 0;
    if (state_1.default.pauses.length > 0) {
        const pause = state_1.default.pauses[state_1.default.pauses.length - 1];
        if (pause.unpausedAt === null) {
            time += state_1.default.currentTime - pause.pausedAt;
        }
        else {
            time += pause.unpausedAt - pause.pausedAt;
        }
    }
    return time;
};
exports.default = getRecentPausedTime;
